import { useLocation, useNavigate, useParams } from "react-router-dom";
import ChevronLeftIcon from "../../../assets/svg/ChevronLeftIcon";
import { useEffect, useState } from "react";
import ViewProfile from "./outlets/ViewProfile";
import Requirements from "./outlets/Requirements";
import Messages from "./outlets/Messages";

const tabs = [
  {
    label: "View profile",
    route: "view-profile",
  },
  {
    label: "Requirements",
    route: "requirements",
  },
  {
    label: "Messages",
    route: "messages",
  },
  {
    label: "Tracker",
    route: "tracker",
  },
];

const RenderBody = ({ activeTab }: { activeTab: number }) => {
  if (activeTab === 1) return <ViewProfile />;
  if (activeTab === 2) return <Requirements />;
  if (activeTab === 3) return <Messages />;
  return null;
};

const RecruitmentAgentDetails = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (route: string) => {
    updateQuery({ tab: route });
  };

  const updateQuery = (newParams: Record<string, string>) => {
    const searchParams = new URLSearchParams(search);
    // Get current query parameters

    // Add or update params
    Object.entries(newParams).forEach(([key, value]) => {
      searchParams.set(key, value); // set() will add or update
    });

    // Update the URL without reloading the page
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    if (searchParams) {
      const tab = searchParams.get("tab");
      if (tab === "view-profile") {
        setActiveTab(1);
      } else if (tab === "requirements") {
        setActiveTab(2);
      } else if (tab === "messages") {
        setActiveTab(3);
      } else if (tab === "tracker") {
        setActiveTab(4);
      }
    }
  }, [search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const tab = searchParams.get("tab");
    if (!activeTab && !tab) {
      updateQuery({ tab: "view-profile" });
    }
    return () => {};
  }, [activeTab]);

  return (
    <div className="flex flex-col flex-1 min-h-0 rounded-lg bg-white w-full p-4 overflow-hidden">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1">
        <ChevronLeftIcon className={"w-5 h-5"} fill={"#2e2e2e"} />
        <span className="font-medium text-xs text-charcoal">
          Back to listing
        </span>
      </button>

      <div className="pl-5 flex flex-col flex-1 min-h-0">
        {/* Tab container */}
        <div className="flex justify-between items-center border-b mt-5 pb-2">
          <div className="flex items-center gap-10">
            {tabs?.map((tab, index) => {
              const isActiveTab = activeTab === index + 1;
              return (
                <button
                  key={tab?.label}
                  onClick={() => handleTabClick(tab?.route)}
                  className={`${
                    isActiveTab ? "border-b border-primary" : "text-gray-500"
                  }`}
                >
                  <span className="text-xs font-medium">{tab?.label}</span>
                </button>
              );
            })}
          </div>
          <button className=" rounded-md bg-primary font-medium text-xs py-2 px-3 text-white">
            Send job requirement
          </button>
        </div>

        {/* Render Body */}
        <RenderBody activeTab={activeTab} />
      </div>
    </div>
  );
};

export default RecruitmentAgentDetails;
